/* eslint-disable no-case-declarations */
/* eslint-disable semi */
import {
  LOADING,
  RESULT,
  LIST,
  LIST_BALANCE,
  INIT_CREATE,
  CREATE,
  READ,
  EDIT,
  UPDATE,
  DELETE,
  DOWNLOAD,
  STOCK_UPDATE,
  LIST_VM,
  DETAIL,
  SET_PRICE_SUBS
} from "./actionTypes";

const INIT_STATE = {
  loading: true,
};

const Refiller = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESULT:
      const newState = {
        ...state,
        loading: false,
      };
      switch (action.payload.actionType) {
        case LIST:
          newState["list"] = action.payload.result;
          break;
        case LIST_VM:
          newState["list_vm"] = action.payload.result;
          break;
        case INIT_CREATE:
          newState["initCreate"] = action.payload.result;
          break;
        case DETAIL:
          newState["detail"] = action.payload.result;
          break;
        case SET_PRICE_SUBS:
          newState["set_price_subs"] = action.payload.result;
          break;
        case CREATE:
          newState["create"] = action.payload.result;
          break;
        case EDIT:
          newState["edit"] = action.payload.result;
          break;
        case DOWNLOAD:
          newState["download"] = action.payload.result;
          break;
        case READ:
          newState["read"] = action.payload.result;
          break;
        case UPDATE:
          newState["update"] = action.payload.result;
          break;
        case STOCK_UPDATE:
          newState["stockUpdate"] = action.payload.result;
          break;
        case DELETE:
          newState["delete"] = action.payload.result;
          break;
      }
      return newState;

    default:
      return state;
  }
};

export default Refiller;
